export default __webpack_public_path__ + "static/media/photo--lg--105.5eb409d3.jpg";